<template>
  <div class="login-container">
    <div class="login-box">
      <div class="logo1 m-auto"> 
        <span class="logo-text" style="align-items: center;">V</span>
      </div>

      <!-- <h2 class="title">Đăng nhập quản trị</h2> -->

      <form @submit.prevent="handlePhone">
        <input
          type="text"
          v-model="phone"
          placeholder="Số điện thoại"
          class="login-input"
        />
        <input
          type="password"
          v-model="password"
          placeholder="Mật khẩu"
          class="login-input"
        />

        <div class="captcha-row">
          <div class="captcha-img">
            <span class="captcha-text">{{ captcha }}</span>
          </div>
          <button type="button" class="refresh-btn" @click="refreshCaptcha">
            <svg width="26" height="26" viewBox="0 0 24 24">
              <path
                fill="#3ec6ff"
                d="M12 6V3L8 7l4 4V8c3.31 0 
                   6 2.69 6 6 0 3.31-2.69 
                   6-6 6s-6-2.69-6-6H4c0 
                   4.42 3.58 8 8 8s8-3.58 
                   8-8-3.58-8-8-8z"
              />
            </svg>
          </button>
        </div>

        <input
          type="text"
          v-model="captchaInput"
          placeholder="Nhập captcha"
          class="login-input"
        />

        <button type="submit" class="login-btn">Đăng nhập</button>
      </form>

      <a href="/" class="home-link">← Về trang chủ</a>
    </div>
  </div>
</template>

<script>
import { postLogin } from '@/components/js/VposService';
import { KEY_PHONE_ID, KEY_SESSION_ID, KEY_USER } from '@/components/listService';

export default {
  name: "LoginQuanTri",
  data() {
    return {
      phone: "",
      password: "",
      captcha: "",
      captchaInput: "",
            isLoading: false,

    };
  },
  mounted() {
    this.refreshCaptcha();
  },
  methods: {
    refreshCaptcha() {
      const chars =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      let result = "";
      for (let i = 0; i < 6; i++) {
        result += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      this.captcha = result;
    },
    async handlePhone() {
      if (this.captchaInput !== this.captcha) {
        alert("Mã xác nhận không đúng!");
        this.refreshCaptcha(); // tạo mã mới
        this.captcha = ""; // xóa ô nhập mã
        return;
      }
      this.isLoading = true;
      try {
        const res = await postLogin(
          this.phone,
          this.password
        );

        if (res.msgCode == 1) {
          // this.$router.push({ name: "home" });
          localStorage.setItem(KEY_USER, JSON.stringify(res.result));
          localStorage.setItem(KEY_SESSION_ID, res.result.secssion);
          localStorage.setItem(KEY_PHONE_ID, res.result.phone);
          window.location.href = "/quantri/trangchu";

          this.isLoading = false;
        } else if (res.msgCode == 5 || res.msgCode == 4 || res.msgCode == 7) {
          this.logRes = res.msgContent;
          this.isLoading = false;
        }
        console.log(res);
      } catch (err) {
        console.log("Đăng nhập thất bại", err);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;600&display=swap");

.login-container {
  background: linear-gradient(135deg, #4a97de, #3ec6ff);
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Inter", sans-serif;
  padding: 20px;
}

.login-box {
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  border-radius: 16px;
  padding: 40px 32px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  width: 100%;
  max-width: 380px;
  text-align: center;
}

.logo1{
  background: #fff;
  border-radius: 50%;
  width: 82px;
  height: 82px;
  margin: 0 auto 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  /* margin-left: 0px !important; */
}

.logo-text {
  color: #4a97de;
  font-size: 46px;
  font-weight: 700;
}

.title {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 24px;
  color: #fff;
}

form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.login-input {
  height: 48px;
  border-radius: 10px;
  border: 1px solid transparent;
  padding: 0 16px;
  font-size: 16px;
  background: rgba(255, 255, 255, 0.85);
  color: #333;
  font-family: inherit;
  transition: all 0.25s ease;
}

.login-input:focus {
  border-color: #3ec6ff;
  box-shadow: 0 0 0 3px rgba(62, 198, 255, 0.3);
  outline: none;
}

.captcha-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.captcha-img {
  background: #f9f9f9;
  border-radius: 8px;
  height: 48px;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 26px;
  font-weight: 600;
  color: #444;
  letter-spacing: 2px;
  border: 1px solid #ddd;
}

.captcha-text {
  font-family: "Inter", sans-serif;
  filter: blur(0.6px) contrast(1.2);
}

.refresh-btn {
  background: #fff;
  border: none;
  border-radius: 8px;
  width: 42px;
  height: 42px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.25s ease, background 0.2s;
}

.refresh-btn:hover {
  background: #e0f7ff;
  transform: rotate(20deg);
}

.login-btn {
  background: linear-gradient(135deg, #a0e85c, #76d636);
  color: #fff;
  font-size: 18px;
  border: none;
  border-radius: 10px;
  height: 50px;
  cursor: pointer;
  margin-top: 10px;
  font-weight: 600;
  letter-spacing: 0.5px;
  transition: all 0.25s ease;
}

.login-btn:hover {
  background: linear-gradient(135deg, #8fdb4f, #68c32f);
  transform: translateY(-2px);
}

.home-link {
  margin-top: 18px;
  color: #fff;
  font-size: 15px;
  display: inline-block;
  transition: opacity 0.2s;
}
.home-link:hover {
  opacity: 0.85;
}
</style>
